import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
   show(loaderIds: string | string[]) {
    const ids = Array.isArray(loaderIds) ? loaderIds : [loaderIds];
    ids.forEach(id => {
      // pick all elements with that ID (or class)
      const elements = document.querySelectorAll(`#${id}`);
      elements.forEach(el => {
        (el as HTMLElement).style.display = 'flex';
      });
    });
  }

  hide(loaderIds: string | string[]) {
    const ids = Array.isArray(loaderIds) ? loaderIds : [loaderIds];
    ids.forEach(id => {
      const elements = document.querySelectorAll(`#${id}`);
      elements.forEach(el => {
        (el as HTMLElement).style.display = 'none';
      });
    });
  }
}
